class CountdownSignupTimer extends HTMLElement {
  constructor() {
    super();
    this.unitsEl = this.querySelector('[data-countdown-units]');
    this.expiredEl = this.querySelector('[data-countdown-expired]');
    this.daysEl = this.querySelector('[data-countdown-days]');
    this.hoursEl = this.querySelector('[data-countdown-hours]');
    this.minutesEl = this.querySelector('[data-countdown-minutes]');
    this.secondsEl = this.querySelector('[data-countdown-seconds]');

    this.hideOnExpire = this.dataset.hideOnExpire === 'true';
    this.targetDate = new Date(
      Number(this.dataset.year),
      Number(this.dataset.month) - 1,
      Number(this.dataset.day),
      Number(this.dataset.hour),
      Number(this.dataset.minute),
      0
    );
  }

  connectedCallback() {
    if (Number.isNaN(this.targetDate.getTime())) return;

    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  update() {
    const remainingMs = this.targetDate.getTime() - Date.now();

    if (remainingMs <= 0) {
      clearInterval(this.interval);
      this.onExpire();
      return;
    }

    const totalSeconds = Math.floor(remainingMs / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
    if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
    if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
    if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
  }

  onExpire() {
    if (this.hideOnExpire) {
      this.hidden = true;
      return;
    }

    if (this.unitsEl) this.unitsEl.hidden = true;
    if (this.expiredEl) this.expiredEl.hidden = false;
  }
}

customElements.define('countdown-signup-timer', CountdownSignupTimer);
